import '@vaadin/combo-box';
import { componentName, ComboBoxClass } from './ComboBoxClass';

customElements.define(componentName, ComboBoxClass);

export { ComboBoxClass, componentName };
